import Swiper, { Scrollbar } from "swiper";

const swiperContentCarousel = new Swiper(".content-carousel__container .swiper", {
  modules: [Scrollbar],
  freeMode: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  slidesPerView: 1.3,
  breakpoints: {
    1024: {
      slidesPerView: 1.5,
    },
    1280: {
      slidesPerView: 1.3,
    },
    1440: {
      slidesPerView: "auto",
    },
  },
});
